<template>
  <div>
    <div class="row mb-4">
      <div class="col">
        <router-link to="/integrations" class="btn btn-primary btn-no-r">
          Insigths
        </router-link>
        <router-link
          to="/integrations/ratings"
          class="btn btn-secondary btn-no-r btn-no-l"
        >
          Ratings
        </router-link>
        <router-link
          to="/integrations/posts/feed"
          class="btn btn-no-l btn-no-r btn-secondary"
        >
          Posts
        </router-link>
        <router-link
          to="/integrations/posts/tagged"
          class="btn btn-no-l btn-no-r btn-secondary"
        >
          Tagged
        </router-link>
        <router-link to="/integrations" class="btn btn-no-l btn-secondary">
          Ads
        </router-link>
      </div>
    </div>
    <div class="mb-5">
      <!-- KPI CARDS -->
      <div class="row g-3 mb-5">
        <div class="col-md-3">
          <div
            class="kpi-card"
            style="
              background: linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045);
            "
          >
            <div class="top-row">
              <h5>Instagram</h5>
              <div class="kpi-number large">
                {{ formatNumber(platforms.instagram?.revenue) }}
                <small style="font-size: 0.6em">Revenue</small>
                <div class="regular-12 mt-1" v-if="platforms.instagram?.sales">
                  {{ formatNumber(platforms.instagram?.sales) }}
                  <small
                    >Sales ({{
                      Math.round(
                        (platforms.instagram?.sales /
                          platforms.instagram?.reach) *
                          100
                      )
                    }}%)</small
                  >
                </div>
              </div>
            </div>
            <div class="kpi-values">
              <div class="kpi-number">
                <div>
                  {{ formatNumber(platforms?.instagram?.followers) }}
                </div>
                <small>Followers</small>
              </div>
              <div class="kpi-number">
                <div>
                  {{ formatNumber(platforms?.instagram?.reach) }}
                </div>
                <small>Reach</small>
              </div>
              <div class="kpi-number">
                <div>
                  {{ formatNumber(platforms?.instagram?.engagements) }}
                  <small
                    >({{
                      Math.round(
                        (platforms?.instagram?.engagements /
                          platforms?.instagram?.reach) *
                          100
                      )
                    }}%)</small
                  >
                </div>
                <small>Engagement</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div
            class="kpi-card"
            style="background: linear-gradient(135deg, #1877f2, #3b5998)"
          >
            <div class="top-row">
              <h5>Facebook</h5>
              <div class="kpi-number large">
                {{ formatNumber(platforms.facebook?.revenue) }}
                <small style="font-size: 0.6em">Revenue</small>
                <div class="regular-12 mt-1" v-if="platforms.facebook?.sales">
                  {{ formatNumber(platforms.facebook?.sales) }}
                  <small
                    >Sales ({{
                      Math.round(
                        (platforms.facebook?.sales /
                          platforms.facebook?.reach) *
                          100
                      )
                    }}%)</small
                  >
                </div>
              </div>
            </div>
            <div class="kpi-values">
              <div class="kpi-number">
                <div>
                  {{ formatNumber(platforms?.facebook?.followers) }}
                </div>
                <small>Followers</small>
              </div>
              <div class="kpi-number">
                <div>
                  {{ formatNumber(platforms?.facebook?.reach) }}
                </div>
                <small>Reach</small>
              </div>
              <div class="kpi-number">
                <div>
                  {{ formatNumber(platforms?.facebook?.engagements) }}
                  <small
                    >({{
                      Math.round(
                        (platforms?.facebook?.engagements /
                          platforms?.facebook?.reach) *
                          100
                      )
                    }}%)</small
                  >
                </div>
                <small>Engagement</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="kpi-card brand-tiktok">
            <div class="top-row">
              <h5>TikTok</h5>
              <div class="kpi-number large">
                {{ formatNumber(platforms.tiktok?.revenue) }}
                <small style="font-size: 0.6em">Revenue</small>
                <div class="regular-12 mt-1" v-if="platforms.tiktok?.sales">
                  {{ formatNumber(platforms.tiktok?.sales) }}
                  <small
                    >Sales ({{
                      Math.round(
                        (platforms.tiktok?.sales / platforms.tiktok?.reach) *
                          100
                      )
                    }}%)</small
                  >
                </div>
              </div>
            </div>
            <div class="kpi-values">
              <div class="kpi-number">
                <div>
                  {{ formatNumber(platforms?.tiktok?.followers) }}
                </div>
                <small>Followers</small>
              </div>
              <div class="kpi-number">
                <div>
                  {{ formatNumber(platforms?.tiktok?.reach) }}
                </div>
                <small>Reach</small>
              </div>
              <div class="kpi-number">
                <div>
                  {{ formatNumber(platforms?.tiktok?.engagements) }}
                  <small v-if="platforms?.tiktok?.reach"
                    >({{
                      Math.round(
                        (platforms?.tiktok?.engagements /
                          platforms?.tiktok?.reach) *
                          100
                      )
                    }}%)</small
                  >
                </div>
                <small>Engagement</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div
            class="kpi-card"
            style="background: linear-gradient(135deg, #ff8c00, #ffb84d)"
          >
            <div class="top-row">
              <h5>Google</h5>
              <div class="kpi-number large">
                {{ formatNumber(platforms.google?.revenue) }}
                <small style="font-size: 0.6em">Revenue</small>
                <div class="regular-12 mt-1" v-if="platforms.google?.sales">
                  {{ formatNumber(platforms.google?.sales) }}
                  <small>Sales</small>
                </div>
              </div>
            </div>
            <div class="kpi-values">
              <div class="kpi-number">
                <div>
                  {{
                    formatNumber(
                      platforms.google?.views - platforms.google?.profile_views
                    )
                  }}
                </div>
                <small>Search Views</small>
              </div>
              <div class="kpi-number">
                <div>{{ formatNumber(platforms.google?.profile_views) }}</div>
                <small>Map Views</small>
              </div>
              <div class="kpi-number">
                <div>
                  {{ formatNumber(platforms.google?.lead_submissions) }}
                  <small v-if="platforms?.tiktok?.reach"
                    >({{
                      Math.round(
                        (platforms?.google?.lead_submissions /
                          platforms?.google?.views) *
                          100
                      )
                    }}%)</small
                  >
                </div>
                <small>Actions</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- MAIN LAYOUT: LEFT CONTENT + RIGHT REVIEWS -->
      <div class="row g-4">
        <!-- LEFT: TOP POSTS -->
        <div class="col-lg-4">
          <h4 class="fw-bold mb-3">Your top Posts</h4>
          <div class="row g-3">
            <div class="col-12" v-for="post in posts" :key="post.id">
              <div class="card shadow-sm d-flex flex-row overflow-hidden">
                <img
                  :src="post.thumbnail_url ?? post.media_url"
                  class="img-fluid"
                  style="width: 180px; object-fit: cover"
                />
                <div
                  class="
                    p-3
                    flex-grow-1
                    d-flex
                    flex-column
                    justify-content-between
                  "
                >
                  <div>
                    <span class="badge bg-gradient-primary mb-2">{{
                      getReviewPlatformName(post.integration_service)
                    }}</span>
                    <h5 class="mb-1">{{ post.text }}</h5>
                    <p class="text-muted small mb-2">
                      Posted {{ formatDate(post.posted_at) }} -
                      {{ post.username }}
                    </p>
                  </div>
                  <div class="d-flex gap-4 mt-2">
                    <div>
                      <strong>{{ post.reshare_count ?? 0 }}</strong
                      ><br /><span class="text-muted small">Reshare</span>
                    </div>
                    <div>
                      <strong>{{ post.likes_count ?? 0 }}</strong
                      ><br /><span class="text-muted small">Likes</span>
                    </div>
                    <div>
                      <strong>{{ post.comments_count ?? 0 }}</strong
                      ><br /><span class="text-muted small">Comments</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <h4 class="fw-bold mb-3">Top tagged posts</h4>
          <div class="row g-3">
            <div class="col-12" v-for="post in mentions" :key="post.id">
              <div class="card shadow-sm d-flex flex-row overflow-hidden">
                <img
                  :src="post.thumbnail_url ?? post.media_url"
                  class="img-fluid"
                  style="width: 180px; object-fit: cover"
                />
                <div
                  class="
                    p-3
                    flex-grow-1
                    d-flex
                    flex-column
                    justify-content-between
                  "
                >
                  <div>
                    <span class="badge bg-gradient-primary mb-2">{{
                      getReviewPlatformName(post.integration_service)
                    }}</span>
                    <h5 class="mb-1">{{ post.text }}</h5>
                    <p class="text-muted small mb-2">
                      Posted {{ formatDate(post.posted_at) }} -
                      {{ post.username }}
                    </p>
                  </div>
                  <div class="d-flex gap-4 mt-2">
                    <div>
                      <strong>{{ post.reshare_count ?? 0 }}</strong
                      ><br /><span class="text-muted small">Reshare</span>
                    </div>
                    <div>
                      <strong>{{ post.likes_count ?? 0 }}</strong
                      ><br /><span class="text-muted small">Likes</span>
                    </div>
                    <div>
                      <strong>{{ post.comments_count ?? 0 }}</strong
                      ><br /><span class="text-muted small">Comments</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- AGGREGATE REVIEWS -->
        <div class="col-lg-4">
          <h4 class="fw-bold mb-3">Aggregate Reviews</h4>
          <div class="card shadow-sm p-3 mb-4">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 class="mb-1">Overall Rating</h5>
                <span class="fs-4 fw-bold">{{ rating.total }} / 5</span>
                <span
                  class="badge ms-2"
                  :class="{
                    'bg-success': rating.total >= 4.5,
                    'bg-primary': rating.total >= 4 && rating.total < 4.5,
                    'bg-warning': rating.total >= 3 && rating.total < 4,
                    'bg-danger': rating.total < 3,
                  }"
                >
                  {{ badgeText(rating.total) }}
                </span>
              </div>
              <div class="text-end">
                <span class="d-block small text-muted"
                  >Based on {{ rating.count }} reviews</span
                >
              </div>
            </div>
            <div class="mt-2">
              <div class="d-flex align-items-center mb-1">
                <strong class="me-2">★★★★★</strong>
                <div class="progress flex-grow-1 me-2" style="height: 6px">
                  <div
                    class="progress-bar bg-success"
                    :style="'width: ' + aggregatedReviews[5] + '%'"
                  ></div>
                </div>
                <span class="small w-5rem text-end"
                  >{{ aggregatedReviews[5] }}%</span
                >
              </div>
              <div class="d-flex align-items-center mb-1">
                <strong class="me-2">★★★★☆</strong>
                <div class="progress flex-grow-1 me-2" style="height: 6px">
                  <div
                    class="progress-bar bg-primary"
                    :style="'width: ' + aggregatedReviews[4] + '%'"
                  ></div>
                </div>
                <span class="small w-5rem text-end"
                  >{{ aggregatedReviews[4] }}%</span
                >
              </div>
              <div class="d-flex align-items-center mb-1">
                <strong class="me-2">★★★☆☆</strong>
                <div class="progress flex-grow-1 me-2" style="height: 6px">
                  <div
                    class="progress-bar bg-warning"
                    :style="'width: ' + aggregatedReviews[3] + '%'"
                  ></div>
                </div>
                <span class="small w-5rem text-end"
                  >{{ aggregatedReviews[3] }}%</span
                >
              </div>
              <div class="d-flex align-items-center mb-1">
                <strong class="me-2">★★☆☆☆</strong>
                <div class="progress flex-grow-1 me-2" style="height: 6px">
                  <div
                    class="progress-bar bg-orange"
                    :style="'width: ' + aggregatedReviews[2] + '%'"
                  ></div>
                </div>
                <span class="small w-5rem text-end"
                  >{{ aggregatedReviews[2] }}%</span
                >
              </div>
              <div class="d-flex align-items-center">
                <strong class="me-2">★☆☆☆☆</strong>
                <div class="progress flex-grow-1 me-2" style="height: 6px">
                  <div
                    class="progress-bar bg-danger"
                    :style="'width: ' + aggregatedReviews[1] + '%'"
                  ></div>
                </div>
                <span class="small w-5rem text-end"
                  >{{ aggregatedReviews[1] }}%</span
                >
              </div>
            </div>
          </div>

          <!-- RIGHT: LATEST REVIEWS -->
          <h4 class="fw-bold mb-3">Latest Reviews</h4>
          <div class="card shadow-sm p-3">
            <div
              class="d-flex gap-3 mb-4"
              v-for="review in reviews"
              :key="review.id"
            >
              <img
                :src="review.avatar"
                v-if="review.avatar"
                class="review-avatar"
              />
              <div class="flex-grow-1">
                <div class="d-flex align-items-center gap-2 mb-1">
                  <BaseIcon
                    :name="getLogo(review.integration_service)"
                    type="social"
                    class="platform-icon"
                  />
                  <strong>{{
                    getReviewPlatformName(review.integration_service)
                  }}</strong>
                  <span>
                    <template v-if="review.rate_max === 2">
                      <BaseIcon :name="review.rate == 2 ? 'like' : 'dislike'" />
                    </template>
                    <template v-else>
                      <BaseIcon
                        name="star-filled"
                        v-for="i in review.rate"
                        :key="i"
                      />
                      <BaseIcon
                        name="star"
                        v-for="i in review.rate_max - review.rate"
                        :key="i"
                      />
                    </template>
                  </span>
                </div>
                <strong>{{ review.text }}</strong
                ><br />
                <span class="text-muted small"
                  >{{ review.username }} —
                  {{ formatDate(review.posted_at) }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import ws from "@/modules/ws";
import http from "@/modules/http";
import date from "@/modules/date";
import BaseIcon from "../../../components/icons/BaseIcon.vue";

export default {
  name: "Statistics",
  components: { BaseIcon },
  data() {
    return {
      store: useStore(),
      services: [],
      pages: [],
      data: [],
      reviews: [],
      posts: [],
      mentions: [],
      rating: {},
      platforms: {},
      aggregatedReviews: {},
      activeMenu: "ratings",
      selectedService: null,
      selectedPage: null,
      addNew: false,
    };
  },
  computed: {
    warehouses() {
      return this.store.state.warehouses;
    },
    path() {
      return this.$route.path;
    },
  },
  mounted() {
    this.loadData();

    ws.init();

    ws.subscribe("add", "contactMessage", (e) => {
      if (e.session !== this.sessionId) {
        this.messages.push(e.object);
        this.tableKey++;
      }
    });
  },
  methods: {
    getLogo(name) {
      switch (name) {
        case "google":
          return "google-maps";
        default:
          return name;
      }
    },
    getReviewPlatformName(name) {
      switch (name) {
        case "google":
          return "Google review";
        default:
          return name;
      }
    },
    getTypeClass(type) {
      switch (type) {
        case 1:
          return "primary";
        case 2:
          return "failed";
        case 3:
          return "light";
        default:
          return "";
      }
    },
    getTypeName(type) {
      switch (type) {
        case 1:
          return "Feed";
        case 2:
          return "Ads";
        case 3:
          return "Location";
        default:
          return "";
      }
    },
    formatDate(val) {
      return date.format(val, true, false);
    },
    login(service = null) {
      http
        .fetch(`/service-integrations/login/${service ?? this.selectedService}`)
        .then((data) => {
          location.href = data.redirect;
        });
    },
    badgeText(total) {
      if (total >= 4.5) return "Excellent";
      if (total >= 4) return "Very Good";
      if (total >= 3) return "Average";
      return "Poor";
    },
    formatNumber(num) {
      if (num === undefined || num === null) return "-";
      if (num < 1000) return num.toString();

      if (num >= 1000 && num < 10000) {
        // 1,000 - 9,999 → x.xx K
        return (num / 1000).toFixed(2) + " K";
      }

      if (num >= 10000 && num < 100000) {
        // 10,000 - 99,999 → x.x K
        return (num / 1000).toFixed(1) + " K";
      }

      if (num >= 100000 && num < 1000000) {
        // 100,000 - 999,999 → x.xx M
        return (num / 1000000).toFixed(2) + " M";
      }

      if (num >= 1000000) {
        // 1,000,000+ → x.x M
        return (num / 1000000).toFixed(1) + " M";
      }

      return num.toString();
    },
    loadData() {
      let url = "/service-integrations";
      http.fetch(url).then((data) => {
        this.services = data.services;
        this.pages = data.pages;
        this.reviews = data.reviews;
        this.rating = data.rating;
        this.posts = data.posts;
        this.mentions = data.mentions;
        this.aggregatedReviews = data.aggregated_reviews;
        this.platforms = data.platforms;
      });
    },
  },
};
</script>
<style>
.kpi-card {
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(35, 40, 50, 0.06);
  color: #fff;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.kpi-card h5 {
  font-weight: 700;
  margin-bottom: 15px;
}
.kpi-values {
  display: flex;
  justify-content: space-between;
}
.kpi-values div {
  text-align: center;
  flex: 1;
}
.kpi-values .kpi-number:not(:last-child) {
  border-right: 1px solid rgba(255, 255, 255, 0.3);
}
.review-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}
.platform-icon {
  width: 22px;
  height: 22px;
  object-fit: contain;
}
.platform-icon svg {
  width: 100%;
  height: 100%;
}

.brand-tiktok {
  background: linear-gradient(
    135deg,
    #fe2c55,
    #fe2c55 45%,
    #642828 80%,
    #0f5e5c 90%,
    #25f4ee 100%
  );
}

.top-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1em;
}

.top-row h5 {
  margin: 0;
  font-weight: 700;
}

.top-row .kpi-number.large {
  font-size: 1.5em;
  font-weight: 700;
  text-align: right;
  line-height: 0.9;
}
</style>
